import {
  useWatch,
  type Control,
  type UseFormClearErrors
} from 'react-hook-form'
import { useEffect } from 'react'
import type { FlightFormStateType } from '../types'

type FlightFormSubmitValues = {
  clearErrors: UseFormClearErrors<FlightFormStateType>
  control: Control<FlightFormStateType>
  initialValues: FlightFormStateType
}

export default function useFlightFormSubmitValues({
  clearErrors,
  control,
  initialValues
}: FlightFormSubmitValues) {
  const watchFlightType = useWatch({
    control,
    name: 'flightType',
    defaultValue: initialValues.flightType
  })
  const watchFlights = useWatch({
    control,
    name: 'flights',
    defaultValue: initialValues.flights
  })
  const watchCabinClass = useWatch({
    control,
    name: 'cabinClass',
    defaultValue: initialValues.cabinClass
  })
  const watchTravelers = useWatch({
    control,
    name: 'travelers',
    defaultValue: initialValues.travelers
  })
  const watchTripType = useWatch({
    control,
    name: 'tripType',
    defaultValue: initialValues.tripType
  })

  useEffect(() => {
    if (watchFlights && watchFlights.length > 0) {
      clearErrors('flights')
    }
  }, [clearErrors, watchFlights])

  return {
    watchFlightType,
    watchFlights,
    watchCabinClass,
    watchTravelers,
    watchTripType
  }
}
